class quoteblock {
  static get selectors() {
    return {
      bhsSectionBlock: ".bhs-section-block",
      bhsSectionBlockImgDesktop: ".bhs-section-block-img-desktop",
      bhsSectionBlockImgMobile: ".bhs-section-block-img-mobile",
      bhsSectionBlockQ: ".bhs-section-block-q"
    };
  }

  static get classes() {
    return {
      imgPath: "dist/images/jpg/"
    };
  }

  static init() {
    let index;
    let blockDesktop;
    let blockMobile;
    let blockAltDesktop;
    let blockAltMobile;
    let blockQtext;

    let dataQB = [
      {
        "block-desktop": "desktop-image-1.jpg",
        "block-mobile": "mobile-image-1.jpg",
        "block-alt-desktop": "desktop-alt-image-1",
        "block-alt-mobile": "mobile-alt-image-1",
        "block-q-text":
          "We all have goals: We want to matter. We want to be important. We want to have freedom and power to pursue our creative work. We want respect from our peers and recognition for our accomplishments. Not out of vanity or selfishness, but of an earnest desire to fulfill our personal potential.<br> -Ryan Holiday"
      },
      {
        "block-desktop": "desktop-image-2.jpg",
        "block-mobile": "mobile-image-2.jpg",
        "block-alt-desktop": "desktop-alt-image-2",
        "block-alt-mobile": "mobile-alt-image-2",
        "block-q-text":
          "Small businesses no longer need to feel like a deer in the headlights when considering constructing or updating their Web sites. With ClickThings what you see is what you get, unlike some other competitive Web-based Website building tools.<br> -Boomer Esiason"
      },
      {
        "block-desktop": "desktop-image-3.jpg",
        "block-mobile": "mobile-image-3.jpg",
        "block-alt-desktop": "desktop-alt-image-3",
        "block-alt-mobile": "mobile-alt-image-3",
        "block-q-text":
          "Initially we both did a bit of everything towards making each game but as we began to hire people and the business grew we naturally went in different directions, and away from the coalface of development.<br> -Andrew Oliver"
      },
      {
        "block-desktop": "desktop-image-4.jpg",
        "block-mobile": "mobile-image-4.jpg",
        "block-alt-desktop": "desktop-alt-image-4",
        "block-alt-mobile": "mobile-alt-image-4",
        "block-q-text":
          "Lorem ipsum dolor sit amet, pri no quas scaevola efficiendi, solum corrumpit nam ne.  Lorem ipsum dolor sit amet, pri no quas scaevola efficiendi, solum corrumpit nam ne. Usu prima pericula no, an quo quis tation fastidii. Sea adhuc nusquam at."
      }
    ];

    for (index = 0; index < dataQB.length; index++) {
      blockDesktop = dataQB[index]["block-desktop"];
      blockMobile = dataQB[index]["block-mobile"];
      blockAltDesktop = dataQB[index]["block-alt-desktop"];
      blockAltMobile = dataQB[index]["block-alt-mobile"];
      blockQtext = dataQB[index]["block-q-text"];

      $(this.selectors.bhsSectionBlockImgMobile)
        .eq(index)
        .attr("src", this.classes.imgPath + blockMobile)
        .attr("alt", blockAltMobile);
      $(this.selectors.bhsSectionBlockImgDesktop)
        .eq(index)
        .attr("src", this.classes.imgPath + blockDesktop)
        .attr("alt", blockAltDesktop);

      $(this.selectors.bhsSectionBlockQ)
        .eq(index)
        .html(blockQtext);

      //bhsSectionBlockQ
    }
  }
}

module.exports = quoteblock;
